<template>
	<div class="reporting">
		<h4 class="section-title">Reporting</h4>
		<div class="report-list">
			<ViewsReport />
			<ViewsReport />
		</div>
	</div>
</template>

<script>
import ViewsReport from './ViewsReport';
import MentionsReport from './MentionsReport';

export default {
	components: {
		ViewsReport,
		MentionsReport,
	},
};
</script>

<style lang="scss" scoped>
.reporting {
	.report-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}
</style>
